// HTTP 客户端通过此接口获取认证信息，由 app 层在启动时注入具体实现，
// 从而让 shared 层不依赖任何业务层（features/auth）。
export interface AuthProvider {
  getToken: () => string;
  getUuid: () => string;
  getTeamId?: () => string;
  onAuthExpired?: () => void;
}

const noopProvider: AuthProvider = {
  getToken: () => '',
  getUuid: () => '',
  getTeamId: () => '',
};

let current: AuthProvider = noopProvider;

export function setAuthProvider(provider: AuthProvider) {
  current = provider;
}

export function getAuthProvider(): AuthProvider {
  return current;
}
